<button mat-raised-button color="primary" class="create-button" *ngIf="canEdit" (click)="create()">
   Create Meeting
</button>
<app-table
   [config]="tableConfig"
   [filterBar]="filterConfig"
   style="margin-bottom: 20px"
></app-table>
